import React from 'react';
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

const ZoomImage = ({ image, className }) => {
    return (
        <TransformWrapper
            defaultScale={1}
            wheel={{ step: 2.0 }}
            doubleClick={{ step: 2 }}
            pinch={{ step: 2.0 }}
        >
            <TransformComponent>
                <img src={image} className={className} />
            </TransformComponent>
        </TransformWrapper>
    );
};

export default ZoomImage;
